<template>
    <div :class="['popup', 'func-area-pop',visible?'':'hidden']">
        <div class="mask" @click="hideMenu"></div>
        <div class="wrap">
            <div class="userinfo-box" @click="login(scene)">
                <div class="avatar-box">
                    <div class="avatar">
                        <img :src="avatar" />
                    </div>
                </div>
                <a href="javascript:;" class="username">{{username}}</a>
            </div>
            <div class="tool-chest" @click="handleJump">
                <template v-for="(item,index) in menuList">
                    <a
                        :href="item.href"
                        :key="index"
                        :class="['tool-one', item.icon]"
                    >
                        <i></i>
                        {{item.name}}
                        <b v-if="item.extra">{{item.extra}}</b>
                    </a>
                    <div :key="index" v-if="item.breakLineAfter" class="line"></div>
                </template>
                <a v-show="!!avatar" :href="logoutUrl" class="tool-one exit" >
                    <i></i>退出
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import { isLogin } from '../../utils';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        logoutUrl: String,
        login: Function,
        logout: Function,
        isNeibu: Boolean,
        avatar: { type: String, default: '' },
        username: { type: String, default: '请先登录' },
        refreshLogin: Function,
        scene: String,
        hideMenu: Function,
    },
    computed: {

    },
    data() {
        const _isNeibu = this.isNeibu;
        return {
            menuList: [
                {
                    name: '我的课程',
                    href: '//gio.ren/oVLL0RV',
                    icon: 'mycourse',
                    extra: '请前往APP听课',
                    breakLineAfter: true,
                },
                {
                    name: '我的订单',
                    href: `//order.${_isNeibu ? 'neibu.' : ''}koolearn.com/m/user_order/index`,
                    icon: 'myorder',
                },
                {
                    name: '我的拼团',
                    href: `//tuan.${_isNeibu ? 'neibu.' : ''}koolearn.com/fen/orderlist`,
                    icon: 'assemble',
                },
                {
                    name: '我的定金',
                    href: `//order.${_isNeibu ? 'neibu.' : ''}koolearn.com/m/deposit/paid/list?wp_f=w_menu`,
                    icon: 'earnest',
                },
                {
                    name: '我的优惠券',
                    href: `//order.${_isNeibu ? 'neibu.' : ''}koolearn.com/m/coupon/index?wp_f=w_menu`,
                    icon: 'coupon',
                    breakLineAfter: true,
                },
                {
                    name: '我的现金账户',
                    href: `//order.${_isNeibu ? 'neibu.' : ''}koolearn.com/m/cash_account/index?wp_f=w_menu`,
                    icon: 'cash',
                },
                {
                    name: '我的学习卡账户',
                    href: `//order.${_isNeibu ? 'neibu.' : ''}koolearn.com/m/learning_card_account/index?wp_f=w_menu`,
                    icon: 'learning-card',
                },
                {
                    name: '我的课程卡',
                    href: `//order.${_isNeibu ? 'neibu.' : ''}koolearn.com/m/giftcard/index?wp_f=w_menu`,
                    icon: 'course-card',
                    breakLineAfter: true,
                },
            ],
        };
    },
    methods: {
        handleJump(e) {
            e.preventDefault();
            if (isLogin()) {
                window.location.href = e.target.href;
                return;
            }
            this.login(this.scene);
        },
    },
    mounted() {},
};
</script>
<style lang='scss'>

</style>
